const formDataSchema = {
  feilds: [
    {
      id: 1,
      name: "filters",
      text: "Filters",
      visible: false,
      element: "select2",
      required: true,
      input_type: "select",
      placeholder: "Select",
      icon: "user",
      rules: [],
      errors: [],
      value: null,
      valid: false,
      state: "",
      disable: false,
      showSearch: false,
      className: "col pr-0",
    },
    {
      id: 2,
      name: "billingFilters",
      text: "Billing Filters",
      visible: false,
      element: "select2",
      required: true,
      input_type: "select",
      placeholder: "Select",
      icon: "user",
      rules: [],
      errors: [],
      value: null,
      valid: false,
      state: "",
      disable: false,
      showSearch: false,
      className: "col pr-0",
    },
    {
      id: 4,
      name: "date",
      text: "Date",
      visible: true,
      element: "daterange",
      required: true,
      input_type: "date",
      placeholder: "Date",
      icon: "user",
      rules: [
        // {
        //     test: (value) => {
        //         return (value !== null && value.length > 0);
        //     },
        //     message: 'Please Select  Date'
        // }
      ],
      errors: [],
      value: null,
      valid: false,
      state: "",
      disable: false,
      showSearch: false,
      className: "col-4 d-flex pr-0 float-right",
    },
  ],
};

const clearanceFormDataSchema = {
  feilds: [
    {
      id: 1,
      name: "unit_id",
      text: "Unit",
      visible: true,
      element: "select2",
      required: true,
      input_type: "select",
      placeholder: "Unit",
      icon: "user",
      rules: [],
      errors: [],
      value: null,
      valid: false,
      state: "",
      disable: false,
      showSearch: false,
      className: "col",
    },
    {
      id: 2,
      name: "block_id",
      text: "Block",
      visible: true,
      element: "select2",
      requied_input_values: ["unit_id"],
      required: true,
      input_type: "select",
      placeholder: "Block",
      icon: "user",
      rules: [
        {
          type: "disabled",
          test: (value) => {
            let disabled = [];
            clearanceFormDataSchema["feilds"].map((feild) => {
              if (feild.name === "unit_id" && feild.value) {
                disabled.push(true);
              }
            });

            if (disabled.length === 1) {
              if (!disabled.includes(false)) {
                return false;
              } else {
                return true;
              }
            } else {
              return true;
            }
          },
        },
        {
          type: "change_event",
          test: (event) => {
            if (event.name === "unit_id") {
              return true;
            } else {
              return false;
            }
          },
        },
      ],
      errors: [],
      value: null,
      valid: false,
      state: "",
      disabled: true,
      showSearch: false,
      className: "col",
    },
    {
      id: 2,
      name: "floor_id",
      text: "Floor",
      visible: true,
      element: "select2",
      required: true,
      input_type: "select",
      placeholder: "Floor",
      icon: "user",
      rules: [
        {
          type: "disabled",
          test: (value) => {
            let disabled = [];
            clearanceFormDataSchema["feilds"].map((feild) => {
              if (feild.name === "unit_id" && feild.value) {
                disabled.push(true);
              }
              if (feild.name === "block_id" && feild.value) {
                disabled.push(true);
              }
            });

            if (disabled.length === 2) {
              if (!disabled.includes(false)) {
                return false;
              } else {
                return true;
              }
            } else {
              return true;
            }
          },
        },
        {
          type: "change_event",
          test: (event) => {
            if (event.name === "unit_id" || event.name === "block_id") {
              return true;
            } else {
              return false;
            }
          },
        },
      ],
      errors: [],
      value: null,
      valid: false,
      state: "",
      disabled: true,
      showSearch: false,
      className: "col",
    },
    {
      id: 2,
      name: "ot_id",
      text: "OT",
      visible: true,
      element: "select2",
      required: true,
      input_type: "select",
      placeholder: "OT",
      icon: "user",
      rules: [
        {
          type: "disabled",
          test: (value) => {
            let disabled = [];
            clearanceFormDataSchema["feilds"].map((feild) => {
              if (feild.name === "unit_id" && feild.value) {
                disabled.push(true);
              }
              if (feild.name === "block_id" && feild.value) {
                disabled.push(true);
              }
              if (feild.name === "floor_id" && feild.value) {
                disabled.push(true);
              }
            });

            if (disabled.length === 3) {
              if (!disabled.includes(false)) {
                return false;
              } else {
                return true;
              }
            } else {
              return true;
            }
          },
        },
        {
          type: "change_event",
          test: (event) => {
            if (
              event.name === "unit_id" ||
              event.name === "block_id" ||
              event.name === "floor_id"
            ) {
              return true;
            } else {
              return false;
            }
          },
        },
      ],
      errors: [],
      value: null,
      valid: false,
      state: "",
      disabled: true,
      showSearch: false,
      className: "col",
    },
    {
      id: 2,
      name: "doctor_id",
      text: "Doctor",
      visible: true,
      element: "select2",
      required: true,
      input_type: "select",
      placeholder: "Doctor",
      icon: "user",
      rules: [
        {
          // test: (value) => {
          //     return (value !== null && value.length > 0);
          //     return true;
          // },
          // message: 'Gender'
        },
      ],
      errors: [],
      value: null,
      valid: false,
      state: "",
      disable: false,
      showSearch: true,
      className: "col",
    },
    {
      id: 4,
      name: "booking_request_report",
      text: "Date",
      visible: true,
      element: "daterange",
      required: true,
      input_type: "date",
      placeholder: "Date",
      icon: "user",
      rules: [
        // {
        //     test: (value) => {
        //         return (value !== null && value.length > 0);
        //     },
        //     message: 'Please Select  Date'
        // }
      ],
      errors: [],
      value: null,
      valid: false,
      state: "",
      disable: false,
      showSearch: false,
      className: "col-3 d-flex pr-0 float-right",
    },
  ],
};
export { formDataSchema, clearanceFormDataSchema };
